(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/components/game-unavailable.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/components/game-unavailable.js');
"use strict";

const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton;
const GameUnavailable = () => React.createElement("div", {
  className: "padding-3 align-center f-content"
}, React.createElement(Icon, {
  icon: "exclamation-sign",
  size: 900
}), React.createElement("h2", {
  className: "h1 margin-v-1"
}, "N\xE5got gick fel"), React.createElement("p", {
  className: "margin-bottom-2"
}, "Just nu \xE4r KenoXpress inte tillg\xE4ngligt.", React.createElement("br", null), "V\xE4nligen f\xF6rs\xF6k igen senare."), React.createElement(Button, {
  className: "qa-button-start-page",
  inverted: true,
  onClick: () => {
    window.location.href = svs.core.urlMapping.get('startPage');
  }
}, "Till startsidan"));
setGlobal('svs.kenoXpress.react.components.GameUnavailable', GameUnavailable);

 })(window);